// extracted by mini-css-extract-plugin
module.exports = {"container":"RestartGame_container__3EKe2","title":"RestartGame_title__1rRKv","description":"RestartGame_description__3Ti9s"};